import { SCREENS, SITES } from 'ag-common/tools/tracking'
import { addScreen } from './piano-analytics'

let lastPathname

export function trackLocationChange(pathname, role) {
  if (lastPathname === pathname) {
    return
  }
  lastPathname = pathname

  const parts = pathname
    .split('/')
    .map(x => x.trim())
    .filter(x => !!x)
  const level = parts[0]
  const isRoot = parts.length === 1
  const isAzubi = role === 'azubi'

  if (level === 'uebersicht') {
    if (isRoot) {
      addScreen(SITES.startseite, SCREENS.startausbilder)
    }
  }
  if (level === 'meineausbildung') {
    if (isRoot) {
      addScreen(SITES.startseite, SCREENS.startazubi)
    }
  }

  if (level === 'ausbildungsnachweise') {
    if (isRoot) {
      if (isAzubi) {
        addScreen(SITES.ausbildungsnachweise, SCREENS.startazubi)
      } else {
        addScreen(SITES.ausbildungsnachweise, SCREENS.startausbilder)
      }
    } else if (parts[1] === 'neu') {
      addScreen(SITES.ausbildungsnachweise, SCREENS.neu)
    } else {
      addScreen(SITES.ausbildungsnachweise, SCREENS.einzeln)
    }
  }

  if (level === 'ausbildungsplan') {
    if (isRoot) {
      if (isAzubi) {
        addScreen(SITES.ausbildungsplan, SCREENS.startazubi)
      } else {
        addScreen(SITES.ausbildungsplan, SCREENS.startausbilder)
      }
    } else if (parts.includes('static')) {
      addScreen(SITES.ausbildungsplan, SCREENS.informationen)
    } else if (parts.includes('questions')) {
      addScreen(SITES.ausbildungsplan, SCREENS.aufgabenkapiteleinzeln)
    }
  }

  if (level === 'ablaufundtermine') {
    if (isRoot) {
      if (isAzubi) {
        addScreen(SITES.versetzungsplan, SCREENS.startazubi)
      } else {
        addScreen(SITES.versetzungsplan, SCREENS.startausbilder)
      }
    }
  }

  if (level === 'praxisaufgabenoverview') {
    if (isRoot) {
      if (isAzubi) {
        addScreen(SITES.praxisaufgabenoverview, SCREENS.startazubi)
      } else {
        addScreen(SITES.praxisaufgabenoverview, SCREENS.startausbilder)
      }
    }
  }

  if (level === 'next') {
    if (isRoot) {
      if (isAzubi) {
        addScreen(SITES.wissensportal, SCREENS.startazubi)
      } else {
        addScreen(SITES.wissensportal, SCREENS.startausbilder)
      }
    }
  }

  if (level === 'meineorganisation') {
    if (parts[1] === 'meineazubis') {
      addScreen(SITES.meineazubis, SCREENS.meineazubis)
    } else if (parts[1] === 'meineausbilder') {
      addScreen(SITES.meineazubis, SCREENS.meineausbilder)
    }
  }

  if (level === 'benachrichtigungen') {
    if (isRoot) {
      if (isAzubi) addScreen(SITES.benachrichtigungen, SCREENS.startazubi)
      else {
        addScreen(SITES.benachrichtigungen, SCREENS.startausbilder)
      }
    }
  }

  if (level === 'feedback') {
    if (isRoot) {
      addScreen(SITES.feedback, SCREENS.start)
    }
  }

  if (level === 'chat') {
    if (isRoot) {
      addScreen(SITES.chat, SCREENS.startausbilder)
    }
  }
}
